import React, { Component } from 'react';
import { object, number } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import EditRule from './EditRulePanel/EditRule';
import Placeholder from 'ps-components/Placeholder/Placeholder';
import RulesList from './RulesList/RulesList';
import RulesListHeader from './RulesListHeader/RulesListHeader';
import * as dataCutsActionCreators from './DataCutsActions';
import * as modalActionCreators from '../../actions/modal';
import * as rulesActionCreators from './RulesActions';
import { dataCutFacetSearchActions } from '../../reducers/modules/dataCuts/dataCutFacetSearch';

import './RulesContainer.scss';

class RulesContainer extends Component {
  static propTypes = {
    actions: object,
    dataCuts: object,
    rules: object,
    offset: number
  };

  state = { text: '' };

  componentDidMount() {
    const { clearSelectedRule, getRules, name } = this.props.actions;
    clearSelectedRule();
    getRules();

    this.props.actions.search({
      params: {
        es_query: '',
        pageName: name,
        include: {},
        exclude: {},
        offset: 0,
        limit: 50
      },
      clear: true
    });
    document.getElementById('rules__search').addEventListener('keydown', e => this.searchRules(e));
  }

  componentDidUpdate(prevProps) {
    const { setFacetText, setSelectedRule, startEditingRuleName } = this.props.actions;
    const { rules, selectedRule, isEditing } = this.props.rules;
    const { history, location, isModalOpen, match } = this.props;
    const hasRules = rules.length > 0;
    const isInitialLoad = prevProps.rules.rules.length === 0;
    const rbpBasePath = '/market-analysis/rules-based-pricing/';
    const isBasePath = history.location.pathname === rbpBasePath;
    const hasMoreRules = prevProps.rules.rules.length < rules.length;
    const hasLessRules = rules.length < prevProps.rules.rules.length;
    const isCsrPath = history.location.pathname.includes('/compensation-summary-report');
    const ruleId = match && match.params && match.params.ruleId ? match.params.ruleId : null;

    if (hasRules && ruleId && !selectedRule.id) {
      const ruleIds = rules.map(rule => rule.id);
      if (ruleIds.includes(ruleId)) {
        setSelectedRule({ id: ruleId });
      } else {
        setSelectedRule(rules[0]);
        this.pushHistory(rules[0].id);
      }
    }

    if (hasRules && isBasePath && !ruleId && !selectedRule.id) {
      setSelectedRule(rules[0]);
      history.replace(`/market-analysis/rules-based-pricing/rules/${rules[0].id}`);
    }

    if (
      (hasRules && isBasePath && isInitialLoad) ||
      (hasRules && isInitialLoad && isCsrPath && history.action === 'POP')
    ) {
      setSelectedRule(rules[0]);
      this.pushHistory(rules[0].id);
    }

    if (
      hasRules &&
      hasLessRules &&
      prevProps.match &&
      prevProps.match.params &&
      prevProps.match.params.ruleId &&
      ruleId === prevProps.match.params.ruleId
    ) {
      history.goBack();
      setSelectedRule(rules[0]);
      this.pushHistory(rules[0].id);
    }

    if (hasRules && hasMoreRules && selectedRule && selectedRule.id) {
      this.pushHistory(selectedRule.id);
      startEditingRuleName();
    }

    if (
      ruleId &&
      prevProps.match &&
      prevProps.match.params &&
      prevProps.match.params.ruleId &&
      ruleId !== prevProps.match.params.ruleId &&
      !prevProps.location.pathname.includes('/delete') &&
      !prevProps.location.pathname.includes('/settings') &&
      !location.pathname.includes('/compensation-summary-report') &&
      !isEditing
    ) {
      const ruleIds = rules.map(rule => rule.id);

      if (ruleIds.includes(ruleId)) {
        setSelectedRule({ id: ruleId });
      } else {
        setSelectedRule(rules[0]);
      }
    }

    if (
      hasRules &&
      selectedRule &&
      prevProps.rules.selectedRule &&
      Object.keys(prevProps.rules.selectedRule).length > 0 &&
      selectedRule.id !== prevProps.rules.selectedRule.id
    ) {
      const selector = document.querySelector('[id^="facet__search"]');

      if (selector && selector.id) document.getElementById(selector.id).value = '';
      setFacetText('');
    }
  }

  componentWillUnmount() {
    const { clearSelectedRule } = this.props.actions;
    document.getElementById('rules__search').removeEventListener('keydown', e => this.searchRules(e));
    clearSelectedRule();
  }

  createRule = () => {
    const { createRule } = this.props.actions;
    createRule('Untitled Rule');
  };

  clearSearch = () => {
    const { searchRules } = this.props.actions;
    this.setState({ text: '' });
    searchRules('');
  };

  getText = event => {
    event.persist();
    const value = event.target.value;
    this.setState({ text: value });
  };

  openDeleteModal = rule => {
    const { history } = this.props;

    history.push(`${history.location.pathname}/delete`, {
      modal: true,
      modalType: 'DELETE_MODAL',
      modalProps: {
        className: 'rules__delete-modal',
        rule
      },
      component: 'DELETE_MODAL'
    });
  };

  openSettingsModal = rule => {
    const { history } = this.props;
    history.push(`${history.location.pathname}/settings`, {
      modal: true,
      modalType: 'SETTINGS_MODAL',
      modalProps: {
        className: 'rules__settings-modal',
        rule
      },
      component: 'SETTINGS_MODAL'
    });
  };

  pushHistory = ruleID => {
    const { history } = this.props;
    history.push(`/market-analysis/rules-based-pricing/rules/${ruleID}`);
  };

  searchRules(e) {
    const { searchRules } = this.props.actions;
    const { text } = this.state;
    if (e.keyCode == 13) searchRules(text);
  }

  render() {
    const { text } = this.state;
    const { actions, offset } = this.props;
    const { isEditing, rules, ruleName, selectedRule, tempName } = this.props.rules;
    const {
      facetSelection,
      facets,
      isSelected,
      items,
      lastFacetFilteredID,
      lastQueryParams,
      loaded,
      loading,
      searchText,
      searchResultsCount,
      showZeros
    } = this.props;

    const selectedRuleConnection = selectedRule && selectedRule.dataCuts ? selectedRule.dataCuts : [];

    return (
      <section className="rules__container">
        <div className="rules">
          <RulesListHeader
            clearSearch={this.clearSearch}
            createRule={this.createRule}
            getText={this.getText}
            text={text}
          />
          <RulesList
            createRule={this.createRule}
            history={this.props.history}
            isSelected={isSelected}
            openDeleteModal={this.openDeleteModal}
            openSettingsModal={this.openSettingsModal}
            rules={rules}
            selectedRule={selectedRule}
            setSelectedRule={actions.setSelectedRule}
            toggleShowSelected={actions.toggleShowSelected}
          />
        </div>
        {rules.length && facets.length ? (
          <EditRule
            actions={actions}
            dataCuts={items}
            facets={facets}
            facetSelection={facetSelection}
            isEditing={isEditing}
            isSelected={isSelected}
            isLoading={loading}
            isLoaded={loaded}
            lastFacetFilteredID={lastFacetFilteredID}
            lastQueryParams={lastQueryParams}
            name={name}
            ruleName={ruleName}
            searchText={searchText}
            selectedRule={selectedRule}
            selectedRuleConnection={selectedRuleConnection}
            showZeros={showZeros}
            tempName={tempName}
            totalDataCutCount={searchResultsCount}
            searchInputSearch={actions.searchInputSearch}
            offset={offset}
          />
        ) : (
          <Placeholder
            imagePath="/view/static/mp/images/empty_results.svg"
            secondaryText={
              facets.length === 0 ? 'You have no active surveys.' : 'There are no surveys for the selected rule.'
            }
            showText={!loading && (!facets.length || !rules.length)}
          />
        )}
      </section>
    );
  }
}

const mapStateToProps = ({ dataCuts, rules, dataCutFacetSearch }) => {
  return {
    facets: dataCutFacetSearch.facets,
    facetSelection: dataCutFacetSearch.facetSelection,
    isSelected: dataCuts.isSelected,
    items: dataCutFacetSearch.items,
    lastFacetFilteredID: dataCutFacetSearch.lastFacetFilteredID,
    lastQueryParams: dataCutFacetSearch.lastQueryParams,
    loaded: dataCutFacetSearch.loaded,
    loading: dataCutFacetSearch.loading,
    name: dataCutFacetSearch.name,
    searchResultsCount: dataCutFacetSearch.searchResultsCount,
    searchText: dataCuts.searchText,
    showZeros: dataCutFacetSearch.showZeros,
    searchInputSearch: dataCutFacetSearch.searchInputSearch,
    offset: dataCutFacetSearch.offset,
    rules
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      ...dataCutsActionCreators,
      ...dataCutFacetSearchActions,
      ...modalActionCreators,
      ...rulesActionCreators
    },
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(RulesContainer);
